import { useState, useRef } from "react";

// status meanings:
// 'uninitialized' - Chat script not loaded
// 'loading' - Chat script is loading
// 'initialized' - Chat widget is loaded but not open
// 'open' - Chat widget is open and visible
const useTalkdeskChat = () => {
  const [status, setStatus] = useState("uninitialized");
  const webchatRef = useRef(null);

  const loadAndInitChat = () => {
    setStatus("loading");
    if (window.TalkdeskChatSDK) {
      handleChatScriptLoad();
      return;
    }
    const divContainer = document.createElement("div");
    divContainer.id = "talkdesk-chat-container";
    document.body.appendChild(divContainer);
    const script = document.createElement("script");
    script.src = "https://talkdeskchatsdk.talkdeskapp.com/v2/talkdeskchatsdk.js";
    script.async = true;
    script.onload = handleChatScriptLoad;
    document.body.appendChild(script);
  };

  const handleChatScriptLoad = async () => {
    if (window.TalkdeskChatSDK && status !== "initialized" && status !== "open") {
      const talkDeskProps = {
        touchpointId: "7218585a6ecd4dc7a38b4767b75d63d2",
        region: "td-us-1"
      };
      const talkDeskConfig = {
        enableValidation: false,
        enableEmoji: true,
        enableUserInput: true,
        enableAttachments: true,
        enableResponsiveLayout: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          window.navigator.userAgent
        ),
        styles: {
          chatThemeColor: "#008733"
        }
      };
      try {
        webchatRef.current = window.TalkdeskChatSDK("talkdesk-chat-container", talkDeskProps);
        await webchatRef.current.init(talkDeskConfig);
        setStatus("open");
        webchatRef.current.open();
      } catch (error) {
        setStatus("initialized");
        // eslint-disable-next-line no-console
        console.error("Failed to initialize chat widget:", error);
      }
    }
  };

  const toggleChat = () => {
    if (status === "uninitialized") {
      loadAndInitChat();
      return;
    }
    if (status === "loading") {
      return;
    }
    if (status === "open") {
      webchatRef.current.close();
      setStatus("initialized");
    } else if (status === "initialized") {
      webchatRef.current.open();
      setStatus("open");
    }
  };

  return {
    chatLoading: status === "loading",
    isChatOpen: status === "open",
    toggleChat
  };
};

export default useTalkdeskChat;
